<div class="container">
  <mic-breadcrumb id="preferred-treads-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('preferredTreadsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title preferred-treads-heading" id="casing-size-heading">
    {{ translationService.translate('preferredTreadsText') }}
  </h2>

  <div class="action-bar">
    <button id="reset-filters" class="btn-clear" type="button" mat-flat-button color="accent" (click)="resetFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <button id="save" class="btn-primary" type="button" mat-flat-button color="primary" (click)="createTread()">
      <mat-icon>add</mat-icon>
      {{ translationService.translate('addNewText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="preferredTreadCodeDropdown"
          label="{{ translationService.translate('codeText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByCodeText') }}"
          placeholder="{{ translationService.translate('searchByCodeText') }}"
          [formGroup]="filterForm"
          formControlName="codes"
          [data]="preferredTreadCodeList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="preferredTreadDescriptionDropdown"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByDescText') }}"
          placeholder="{{ translationService.translate('searchByDescText') }}"
          [formGroup]="filterForm"
          formControlName="descriptions"
          [data]="preferredTreadDescriptionList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="preferred-tread-table" class="cam-table table-container">
    <mic-table appCopyOnSelect #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container id="table-menu" *micTableRowMenu="let item">
        <button id="delete-button" type="button" [disabled]="isDeletable(item)" mat-menu-item (click)="showDeleteModal(item)">
          <mat-icon class="delete-icon-only">delete</mat-icon> {{ translationService.translate('deleteText') }}
        </button>
        <button
          [disabled]="this.productSaveDisabled"
          id="assign-to-customer-button"
          type="button"
          mat-menu-item
          (click)="assignToCustomer(item)"
        >
          <mat-icon>person_add_alt</mat-icon> {{ translationService.translate('assignToCustomerMenuText') }}
        </button>
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>Are you sure you want to delete the Casing Grade?</ng-template>
</div>
